import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, interval, Observable, of, repeat, Subject, switchMap, takeUntil } from 'rxjs';

@UntilDestroy()
@Directive({
  selector: '[appScrollableXBox]',
  exportAs: 'appScrollableXBox',
})
export class ScrollableXBoxDirective implements AfterViewInit {
  private readonly _canScrollStart = new BehaviorSubject<boolean>(false);
  readonly canScrollStart$ = this._canScrollStart.asObservable();

  private readonly _canScrollEnd = new BehaviorSubject<boolean>(true);
  readonly canScrollEnd$ = this._canScrollEnd.asObservable();

  scrollInterval$: Observable<any>;

  private readonly _stopInterval = new Subject<void>();
  private readonly _startInterval = new Subject<void>();

  private scrollStep: number;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    this._canScrollEnd.next(this.element.scrollWidth > this.element.clientWidth);

    this.scrollStep = this.element.children[0].scrollWidth + 10;

    this.scrollInterval$ = interval(5000).pipe(
      untilDestroyed(this),
      switchMap(() => of(this.scroll('forward', true))),
      takeUntil(this._stopInterval),
      repeat({ delay: () => this._startInterval })
    );

    this.scrollInterval$.subscribe();
  }

  private get element() {
    return this.elementRef.nativeElement;
  }

  scroll(direction: 'forward' | 'backward', automatic = false) {
    const scrollLeft = this.element.scrollLeft + (direction === 'forward' ? this.scrollStep : -this.scrollStep);

    if (!automatic) {
      this._stopInterval.next();
      this._startInterval.next();

      this.element.scrollLeft = scrollLeft;
    } else {
      this.element.scrollLeft = this._canScrollEnd.getValue() ? scrollLeft : 0;
    }
  }

  private setCanScroll(): void {
    setTimeout(() => {
      this._canScrollStart.next(this.element.scrollLeft > 0);
      this._canScrollEnd.next(
        Math.floor(this.element.scrollLeft + this.element.clientWidth) !== Math.floor(this.element.scrollWidth)
      );
    }, 100);
  }

  @HostListener('scroll') watchScroll() {
    this.setCanScroll();
  }
}
